import React, {useEffect} from 'react';
import {Card, Grid} from 'semantic-ui-react';
import Translations from '../../components/Translations';

const SuccessPage = () => {
    useEffect(() => {
        const redirectTimer = setTimeout(() => window.location.replace('/completed'), 3000);
        return () => clearTimeout(redirectTimer);
    }, []);

    return (
        <main className="selection-completed">
            <Grid container centered stackable columns={1} padded="vertically">
                <Grid.Column>
                    <Card fluid className="selection-completed-card">
                        <Card.Content>
                            <svg className="selection-completed-icon" viewBox="0 0 2048 2048" aria-hidden="true" focusable="false">
                                <path fill="currentColor" d="M1024 0q141 0 272 36t244 104t207 160t161 207t103 245t37 272q0 141-36 272t-104 244t-160 207t-207 161t-245 103t-272 37q-141 0-272-36t-244-104t-207-160t-161-207t-103-245t-37-272q0-141 36-272t104-244t160-207t207-161T752 37t272-37zm603 685l-136-136l-659 659l-275-275l-136 136l411 411l795-795z" />
                            </svg>
                            <h1><Translations text="selection.complete_title" backup="Selection complete! 🥳" /></h1>
                            <p>
                                <Translations textKey="selection.complete_desc3" data={{support: 'hello@ltria.com'}}>
                                    Need help? Send an email to <a href="mailto:hello@ltria.com">hello@ltria.com</a> with a screenshot attached.
                                </Translations>
                            </p>
                        </Card.Content>
                    </Card>
                </Grid.Column>
            </Grid>
        </main>
    );
};

export default SuccessPage;
